const handleViewportHeight = () => {
    const viewportHeight = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${viewportHeight}px`);
}

const handleForbidden = () => {
    dispatchEvent(
        new CustomEvent("notify", {
            detail: {
                title: "Oops!",
                text: "Your session has expired. Please log in again to continue accessing the content.",
                type: "info"
            }
        })
    );

    setTimeout(() => location.reload(), 2500);
}

const overflow = document.documentElement.style.overflow;
const paddingRight = document.documentElement.style.paddingRight;
const preventDefault = (e) =>  e.preventDefault();

const disableScroll = () => {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth

    document.documentElement.style.overflow = 'hidden';
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`;

    if(document.getElementById('topbar') instanceof HTMLElement){
        document.getElementById('topbar').style.paddingRight = `${scrollbarWidth}px`;
    }

    document.body.addEventListener('touchmove', preventDefault, { passive: false });
}

const enableScroll = () => {
    setTimeout(() => {
        document.documentElement.style.overflow = overflow;
        document.documentElement.style.paddingRight = paddingRight;

        if(document.getElementById('topbar') instanceof HTMLElement){
            document.getElementById('topbar').style.paddingRight = '0px';
        }

        document.body.removeEventListener('touchmove', preventDefault, { passive: false });
    }, 200);
}

export { handleViewportHeight, handleForbidden, disableScroll, enableScroll};
